import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import useFavouritesCollectionStore from "@stores/shared/useFavouritesCollectionStore";
import useFavouritesUserCollectionStore from "@stores/client/useFavouritesUserCollectionStore";

export const useCollectionOperations = (itemData = {}) => {
  const { t } = useTranslation();
  const { createCollection, updateCollection, deleteCollection } =
    useFavouritesCollectionStore();

  const { createUserCollection } = useFavouritesUserCollectionStore();

  const handleCreateCollection = useCallback(
    (formData, onSuccess) => {
      const successCallback = () => {
        toast.success(t("favourites.collectionCreateSuccess"));
        onSuccess?.();
      };

      const errorCallback = (err) => {
        toast.error(t("favourites.collectionCreateError"));
        console.error("Error creating collection:", err);
      };

      createCollection(formData, successCallback, errorCallback);
    },
    [createCollection, t],
  );

  const handleCreateUserCollection = useCallback(
    (formData, onSuccess) => {
      const successCallback = () => {
        toast.success(t("favourites.collectionCreateSuccess"));
        onSuccess?.();
      };

      const errorCallback = (err) => {
        toast.error(t("favourites.collectionCreateError"));
        console.error("Error creating collection:", err);
      };

      createUserCollection(formData, successCallback, errorCallback);
    },
    [createUserCollection, t],
  );

  const handleUpdateCollection = useCallback(
    (collectionId, formData, onSuccess) => {
      const successCallback = () => {
        toast.success(t("favourites.collectionUpdateSuccess"));
        onSuccess?.();
      };

      const errorCallback = (err) => {
        toast.error(t("favourites.collectionUpdateError"));
        console.error("Error updating collection:", err);
      };

      updateCollection(collectionId, formData, successCallback, errorCallback);
    },
    [updateCollection, t],
  );

  const handleDeleteCollection = useCallback(() => {
    deleteCollection(
      itemData.id,
      () => toast.success(t("favourites.collectionDeleteSuccess")),
      (error) => {
        toast.error(t("favourites.collectionDeleteError"));
        console.error("Error deleting collection:", error);
      },
    );
  }, [itemData.id, deleteCollection]);

  return {
    handleDeleteCollection,
    handleCreateCollection,
    handleUpdateCollection,
    handleCreateUserCollection,
  };
};
